export default __webpack_public_path__ + "static/media/score_bg.c9d51139.png";